/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction, AnyAction } from "@reduxjs/toolkit";
import { ThunkDispatch } from "redux-thunk";
import _ from "lodash";
import { LoadingState } from "../../Common";
import { Trigger } from "../Models/Trigger";
import * as api from "../Api";

export type TriggerState = {
  loadingState: LoadingState;
  error?: string;
  triggers: Trigger[];
};

const initialState: TriggerState = {
  loadingState: {
    isLoaded: false,
    isLoading: false,
    errored: false
  },
  triggers: []
};

const slice = createSlice({
  name: "triggers",
  initialState,
  reducers: {
    startLoading: state => {
      state.loadingState = {
        isLoaded: false,
        isLoading: true,
        errored: false
      };
    },
    finishLoading: (state, action: PayloadAction<Trigger[]>) => {
      state.loadingState = {
        isLoaded: true,
        isLoading: false,
        errored: false
      };
      state.triggers = action.payload;
    },
    errorLoading: (state, action: PayloadAction<string>) => {
      state.loadingState = {
        isLoaded: false,
        isLoading: false,
        errored: true
      };
      state.error = action.payload;
    },
    invalidate: () => initialState
  }
});

export default slice.reducer;

export const { invalidate } = slice.actions;

export const load = () => async (dispatch: ThunkDispatch<unknown, unknown, AnyAction>) => {
  dispatch(slice.actions.startLoading());
  try {
    const triggers = await api.getTriggers();
    dispatch(slice.actions.finishLoading(triggers as Trigger[]));
  } catch (e) {
    dispatch(slice.actions.errorLoading((e as Error).message));
  }
};
